

import AMapLoader from "@amap/amap-jsapi-loader";

// 高德地图的配置并加载
export async function initAMap(mapId = "") {
  try {
    // 安全配置
    window._AMapSecurityConfig = {
      securityJsCode: process.env.VUE_APP_GAODE_MAP_SECRET,
    };

    // 加载高德地图API及相关插件
    const AMap = await new Promise((resolve, reject) => {
      AMapLoader.load({
        key: process.env.VUE_APP_GAODE_MAP_KEY,
        version: "2.0",
        plugins: ["AMap.Scale", "AMap.MoveAnimation"],
      }).then(resolve).catch(reject);
    });

    return AMap;
  } catch (error) {
    console.error('初始化高德地图失败:', error);
    throw error;
  }
}
